export default __webpack_public_path__ + "static/media/warsztaty.6b54da52.jpg";